import React from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./ui/select";
import { useTranslation } from "react-i18next";

const languages = [
  {
    value: 'es',
    label: 'Español'
  },
  {
    value: 'en',
    label: 'English'
  },
  {
    value: 'ms',
    label: 'Bahasa Melayu'
  },
  {
    value: 'ar',
    label: 'العربية'
  }

];

interface LanguageSelectorProps {
  value: string;
  onValueChange: (language: string) => void;
  className?: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  value,
  onValueChange,
  className = ""
}) => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (selectedLanguage: string) => {
    onValueChange(selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
  };

  return (
    <Select
      onValueChange={handleLanguageChange}
      value={value}
    >
      <SelectTrigger className={className}>
        <SelectValue>
          {languages.find(lang => lang.value === value)?.label || 'select_language'}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {languages.map((language) => (
          <SelectItem key={language.value} value={language.value}>
            {language.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
